import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { hsaContributionsIntial } from 'enrollment/services';
import {
    HSAContributionCardBackground,
    HSAContributionCardBoder,
    DontWantContributeBanner,
} from './HSAContributionStyled';
import { convertCurrency } from "enrollment/utils";

export function DontContributeER() {
    const { t } = useTranslation('pages.financial');
    const newHSAData = useSelector(hsaContributionsIntial);
    const currentPlanYear = newHSAData.current_plan_year;

    return (
        <HSAContributionCardBoder>
            <HSAContributionCardBackground>
                <div className="text-center py-3_5">
                    <div className="title-large">{convertCurrency(t('newHSA.noContributionAmount'))}</div>
                    <div className="title-medium semiBold">
                        {t('newHSA.title', { currentPlanYear })}{' '}
                    </div>
                    <div className="title-small">{t('newHSA.description')}</div>
                </div>
            </HSAContributionCardBackground>
            <DontWantContributeBanner>
                <div className="px-4 py-3 mt-3" data-testid="dont-contribute">
                    {t('newHSA.noContributionMessage')}
                </div>
            </DontWantContributeBanner>
        </HSAContributionCardBoder>
    );
}
